const mn = {
  brand: {
    name: 'POWER',
    desc: 'AUTO SERVICE',
  },

  nav: {
    services: 'Үйлчилгээ',
    prices: 'Үнэ',
    about: 'Бидний тухай',
    contacts: 'Холбоо барих',
    contactUs: 'Холбогдох',
    workHours: 'Өдөр бүр 10:00–19:00',
  },

  hero: {
    badge: '⭐ Авто үйлчилгээний зах зээлд 10 гаруй жил',
    title1: 'Мэргэжлийн',
    titleAccent: ' авто засвар',
    title2: 'Улаанбаатарт',
    text: 'Бүх маркийн автомашины засвар үйлчилгээний бүх төрлийн ажлыг гүйцэтгэнэ. Ажилд 1 жилийн баталгаа. Орчин үеийн тоног төхөөрөмж, туршлагатай мастерууд.',
    stat1num: '12,000+',
    stat1label: 'сэтгэл ханамжтай үйлчлүүлэгч',
    stat2num: '10+',
    stat2label: 'жилийн туршлага',
    stat3num: '1',
    stat3label: 'жилийн баталгаа',
    btnBooking: 'Засварт бүртгүүлэх',
    btnPrices: 'Үнэ мэдэх',
    card1title: 'Үнэгүй оношилгоо',
    card1text: '5,000 ₽-с дээш засварт',
    card2title: 'Оригинал сэлбэг',
    card2text: '1-2 хоногт нийлүүлэлт',
    card3title: 'Яаралтай засвар',
    card3text: 'тухайн өдөртөө',
  },

  services: {
    title: 'Манай үйлчилгээ',
    subtitle: 'Бүх маркийн автомашины засвар, үйлчилгээний бүрэн хүрээ',
    more: 'Дэлгэрэнгүй →',
  },

  advantages: {
    title: 'Яагаад биднийг сонгох вэ',
    subtitle: 'Бид таны авто машинд найдвартай, чанартай, баталгаатай үйлчилгээг түргэн шуурхай, тав тухтай хүргэж таны авто машины аюулгүй байдлыг хангаж үйлчилнэ',
    items: [
      { icon: '🕐', title: 'Хурдан засвар', text: 'Ихэнх ажлыг тухайн өдөртөө гүйцэтгэнэ. Нарийн засвар — 1-3 хоног.' },
      { icon: '💎', title: '1 жилийн баталгаа', text: 'Гүйцэтгэсэн бүх ажилд баталгаа олгоно.' },
      { icon: '📋', title: 'Ил тод үнэ', text: 'Ажил эхлэхээс өмнө үнийг тохиролцоно. Нуугдмал төлбөргүй.' },
      { icon: '🚗', title: 'Бүх маркийн авто', text: 'Хямд үнэтэйгээс премиум хүртэл бүх маркийн автомашинтай ажиллана.' },
      { icon: '🔧', title: 'Мэргэжлийн тоног төхөөрөмж', text: 'Тэргүүлэх үйлдвэрлэгчдийн орчин үеийн стенд, сканер, багаж хэрэгсэл.' },
      { icon: '📱', title: 'Онлайн бүртгэл', text: '1 минутад вэбсайт эсвэл мессенжерээр тохиромжтой цагт бүртгүүлнэ үү.' },
    ],
  },

  about: {
    title: 'Манай авто засварын тухай',
    text1: 'ПОВЕР АВТО СЕРВИС нь Улаанбаатар дахь орчин үеийн бүрэн циклийн авто засвар юм. Бид 2016 оноос хойш ажиллаж, 12,000 гаруй автомашинд үйлчилсэн.',
    text2: 'Манай мэргэжилтнүүд тогтмол сургалтанд хамрагдаж, мэргэжлээ байнга дээшлүүлдэг. Зөвхөн мэргэжлийн тоног төхөөрөмж, оригинал сэлбэг ашигладаг.',
    features: [
      { icon: '🏆', title: 'Гэрчилгээтэй төв', text: 'Бүх төрлийн ажлын лиценз, гэрчилгээ' },
      { icon: '👥', title: 'Туршлагатай баг', text: 'Мастеруудын дундаж стаж — 8 жилээс дээш' },
      { icon: '🔒', title: 'Чанарын баталгаа', text: 'Ажилд 1 жилийн баталгаа' },
      { icon: '💰', title: 'Шударга үнэ', text: 'Нуугдмал төлбөр, тулгасан үйлчилгээгүй' },
    ],
    yearsLabel: 'жилийн ажил',
    imageTitle: 'Манай авто засвар',
  },

  prices: {
    title: 'Үйлчилгээний үнэ',
    subtitle: 'Үндсэн ажлуудын одоогийн үнэ. Нарийн үнийг оношилгооны дараа тодруулна.',
    headerWork: 'Ажлын төрөл',
    headerPrice: 'Үнэ',
    note: 'Сэлбэгийн зардлыг оруулаагүй ажлын үнэ. Нарийн үнийг мастер оношилгооны дараа тооцоолно.',
  },

  booking: {
    title: 'Засварт бүртгүүлэх',
    text: 'Хүсэлт үлдээгээрэй, бид удахгүй нарийвчилсан мэдээлэл авахаар эргэж залгана.',
    benefit1: 'Засвартай үнэгүй оношилгоо',
    benefit2: 'Удахгүй эргэж залгана',
    benefit3: 'Үзлэгийн дараа тогтмол үнэ',
    benefit4: 'Бүх ажилд баталгаа',
    orCall: 'Эсвэл бидэнд залгаарай:',
    nameLabel: 'Таны нэр',
    namePlaceholder: 'Бат Болд',
    phoneLabel: 'Утас',
    carLabel: 'Машины марк, загвар',
    carPlaceholder: 'TOYOTA Land Cruiser 200 2020',
    serviceLabel: 'Үйлчилгээ',
    serviceDefault: 'Үйлчилгээ сонгох',
    dateLabel: 'Хүссэн огноо',
    commentLabel: 'Тайлбар',
    commentPlaceholder: 'Асуудал эсвэл хүсэлтээ тайлбарлана уу...',
    submit: '📋 Хүсэлт илгээх',
    sending: 'Илгээж байна...',
    privacy: 'Товчлуурыг дарснаар та хувийн мэдээлэл боловсруулах бодлогыг зөвшөөрч байна',
  },

  carousel: {
    title: 'Манай сервисийн байнгын зочид',
    subtitle: 'Бидний байнга үйлчилдэг автомашинууд',
    imageAlt: 'Автомашин',
    items: [
      'TOYOTA Land Cruiser Prado 120',
      'TOYOTA Land Cruiser Prado 150',
      'TOYOTA Hilux 185',
      'TOYOTA Hilux 215',
      'LEXUS RX 450',
      'TOYOTA Land Cruiser 200',
    ],
  },

  gallery: {
    title: 'Манай авто засвар',
    subtitle: 'Орчин үеийн тоног төхөөрөмж, тав тухтай нөхцөл',
    items: [
      { emoji: '🔧', title: 'Засварын бүс' },
      { emoji: '🖥️', title: 'Оношилгоо' },
      { emoji: '🏗️', title: 'Өргөгч' },
      { emoji: '🛞', title: 'Дугуй засвар' },
      { emoji: '⚙️', title: 'Хүлээлгийн талбай' },
      { emoji: '🧰', title: 'Багаж хэрэгсэл' },
    ],
  },

  contacts: {
    title: 'Холбоо барих',
    subtitle: 'Бидэнд ирэх эсвэл тохиромжтой аргаар холбогдоорой',
    address: 'Хаяг',
    addressValue: 'Улаантбаатар хот, СБД, 12-Р ХОРОО, 32-ЫН ТОЙРОГ, НОМИНГИЙН АРД, ПОВЕР АВТО СЕРВИС',
    phone: 'Утас',
    phone2: 'Утас 2',
    email: 'Имэйл',
    schedule: 'Ажлын цаг',
    weekdays: 'Амралтын өдөргүй, өдөр бүр: 10:00 — 19:00',
    nightSurcharge:
      'Шөнийн ээлжид мэргэжилтний дуудлага — үйлчилгээний үнэ дээр нэмж 200 000 ₮.',
    map: 'Газрын зураг',
    mapHint: 'Эндээс Яндекс/Google газрын зураг оруулна',
  },

  contact: {
    title: 'Бидэнтэй холбогдох',
    subtitle: 'Тохиромжтой аргаа сонгоно уу',
    callTitle: 'Залгах',
    callDesc: 'Одоо холбогдоорой',
    formTitle: 'Мэдээлэл үлдээх',
    formDesc: 'Удахгүй эргэж залгана',
    formTag: 'Удахгүй хариулна',
    orWrite: 'Мессенжерээр бичнэ үү:',
    back: 'Буцах',
    leaveContacts: 'Мэдээллээ үлдээнэ үү',
    leaveContactsDesc: 'Менежер мэдэгдэл хүлээн авч тантай холбогдоно',
    nameLabel: 'Таны нэр',
    namePlaceholder: 'Бат Болд',
    phoneLabel: 'Утас',
    preferredContact: 'Тантай яаж холбогдох вэ?',
    byPhone: 'Утсаар',
    tgUsernameLabel: 'Таны Telegram username',
    tgUsernamePlaceholder: '@username',
    tgUsernameHint: 'Бид танд бичих боломжтой болохын тулд Telegram хэрэглэгчийн нэрээ оруулна уу',
    messageLabel: 'Мессеж',
    messagePlaceholder: 'Асуултаа тайлбарлана уу...',
    sendButton: '📨 Хүсэлт илгээх',
    sending: 'Илгээж байна...',
    privacy: 'Товчлуурыг дарснаар та хувийн мэдээлэл боловсруулахыг зөвшөөрч байна',
    errorRequired: 'Заавал бөглөх талбаруудыг бөглөнө үү',
    errorPhone: 'Утасны дугаараа бүрэн оруулна уу',
    errorTgUsername: 'Telegram хэрэглэгчийн нэрээ оруулна уу',
    errorTgUsernameShort: 'Username хэт богино (хамгийн багадаа 3 тэмдэгт)',
    errorSend: 'Алдаа гарлаа. Залгаж үзнэ үү.',
    successTitle: 'Хүсэлт илгээгдлээ!',
    successDesc: 'Менежер удахгүй тантай холбогдоно.',
    close: 'Хаах',
  },

  footer: {
    about: 'Улаанбаатар дахь мэргэжлийн бүрэн циклийн авто засвар. Бүх маркийн автомашины засвар, баталгаатай.',
    servicesTitle: 'Үйлчилгээ',
    svcDiag: 'Сэгсэрдэг оношилгоо',
    svcComputer: 'Компьютер оношилгоо',
    svcBalance: 'Дугуйн баланс тохиргоо',
    svcAlignment: 'Тэнхлэг тохиргоо',
    svcOil: 'Моторын тос солих',
    infoTitle: 'Мэдээлэл',
    aboutCompany: 'Компанийн тухай',
    privacyPolicy: 'Нууцлалын бодлого',
    contactsTitle: 'Холбоо барих',
    copyright: 'Бүх эрх хамгаалагдсан.',
    disclaimer: 'Вэбсайт мэдээллийн зорилготой.',
  },

  videos: {
    title: 'Манай сервисийн видео',
    subtitle: 'Бид хэрхэн ажилладагийг үзнэ үү',
    items: [
      { id: 'kuTJUYci3c4', title: 'Вибрацыонная диагностика автомобиля' },
      { id: 'MsfwwIzWCGw', title: 'Оношилгоо' },
      { id: '9FR1oo2qM5g', title: 'Машины компьютерийн оношилгоо' },
      { id: 'ocncIUsGCsM', title: 'Дугуй тэнцвэржүүлэх үйлчилгээ' },
      { id: 'L7V6p91ZIKE', title: 'Дугуй жигдлэх тохируулга' },
    ],
  },

  parts: {
    toggleBtn: 'Автомашины загвараар сэлбэгийн үнэ',
    oilsLabel: 'Тос, шүүр',
    partsLabel: 'Явах эд ангийн сэлбэг',
    headerName: 'Нэр',
    headerQty: 'Тоо',
    headerBrand: 'Бренд',
    headerPrice: 'Нэгж үнэ',
    disclaimer: 'Энэхүү үнэ нь жишиг бөгөөд 2026 онд хүчинтэй. Эцсийн үнэ нь оношилгооны үр дүнгээс хамаарна. Манай төвөөс сэлбэг худалдаж авсан тохиолдолд ихэнх угсралтыг үнэ төлбөргүй хийж өгнө.',
  },

  servicePage: {
    back: '← Нүүр хуудас руу буцах',
    pricesTitle: 'Ажлын үнэ',
  },

};

export default mn;
